import type { ChatTurn, TicketProposal } from '~/utils/agent-chat';
import { canOfferTicket } from '~/utils/agent-chat-history';

/** The `max` rules of `title` and `body` in SupportTicketController::store() of pos-backend. */
export const TICKET_TITLE_MAX_LENGTH = 255;
export const TICKET_BODY_MAX_LENGTH = 10000;

/**
 * The ticket card and the "チケットにする" menu item follow the rule of canOfferTicket(). A system
 * manager gets a chat token without ticket rights, and agent-api never proposes a ticket to one.
 */
export const canUseTicketCard = canOfferTicket;

export interface TicketDraft {
  title: string;
  summary: string;
}

/**
 * The request of the existing ticket endpoint. The ticket gets the title and the summary only,
 * with no chat transcript. The summary is the first message of the ticket.
 */
export function ticketPayload(shopUid: string, draft: TicketDraft) {
  return {
    shopUid,
    title: draft.title.trim().slice(0, TICKET_TITLE_MAX_LENGTH),
    body: draft.summary.trim().slice(0, TICKET_BODY_MAX_LENGTH),
  };
}

export function ticketDraftValid(shopUid: string | null | undefined, draft: TicketDraft): boolean {
  return Boolean(shopUid) && draft.title.trim() !== '' && draft.summary.trim() !== '';
}

/**
 * The route of a ticket. The uid of an old session comes from `ticket_uid` of agent-api, and the
 * contract says that nothing trusts that value. The encoding keeps it inside the ticket route.
 */
export function ticketLink(ticketUid: string): string {
  return `/support/${encodeURIComponent(ticketUid)}`;
}

/** The newest ticket proposal of the conversation, or null. */
export function latestProposal(turns: readonly ChatTurn[]): TicketProposal | null {
  for (let index = turns.length - 1; index >= 0; index--) {
    const proposal = turns[index].proposal;
    if (proposal) return proposal;
  }
  return null;
}
